import LockedFeatureCard from "@/components/LockedFeatureCard";

export function LockedHitlDrawer({ onClose, feature }: { onClose: () => void; feature?: string }) {
  return (
    <div className="fixed inset-0 z-50 flex">
      <div className="flex-1 bg-black/60" onClick={onClose} />
      <div className="relative h-full w-full max-w-md border-l border-amber-400/30 bg-background p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-xs uppercase tracking-wide text-amber-300">Pro toolkit</p>
            <h3 className="text-xl font-semibold text-foreground">Unlock advanced HITL controls</h3>
          </div>
          <button
            type="button"
            className="text-sm text-muted-foreground hover:text-primary-foreground dark:text-amber-200"
            onClick={onClose}
          >
            Close
          </button>
        </div>
        <LockedFeatureCard
          className="mt-4"
          title="Advanced HITL workflow"
          description="Upgrade to see workflow graphs, timelines, reasoning trails, and take action directly from approvals."
          featureId={feature ?? "canUseAdvancedHitl"}
        />
      </div>
    </div>
  );
}

export default LockedHitlDrawer;
